// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"541":"sidebar","562":"accounts","809":"account"}[chunkId] || chunkId) + "." + {"541":"68f37778","562":"f83f239b","809":"5fe0f69a","811":"19ce052b"}[chunkId] + ".chunk.js";
};